import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import { UserLayout } from "./components/layout/UserLayout";
import PageHero from "./components/PageHero";
import Text from "./components/Text";
import { ROUTE_PATHS } from "../../constants/routeConstants";
import { useSendContactMessageMutation } from "../../stores/api/contacts.api";
import { useFetchContactPageQuery } from "../../stores/api/pages.api";
const FacebookIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);
const TwitterXIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const InstagramIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);
const TiktokIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.24 8.24 0 0 0 4.83 1.56V6.79a4.85 4.85 0 0 1-1.06-.1z" />
  </svg>
);
const PinterestIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
  </svg>
);
const WhatsAppIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);
const LinkedInIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);
const GitHubIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
  </svg>
);

const STORE_INFO = {
  address: "66 Mott St, New York, New York, Zip Code: 10006, AS",
  phone: "(623) 934-2400",
  email: "EComposer@example.com",
  openTime:
    "Our store has re-opened for shopping, exchange Every day 11am to 7pm",
};

const SOCIAL_ICONS = {
  facebook: <FacebookIcon />,
  x: <TwitterXIcon />,
  twitter: <TwitterXIcon />,
  instagram: <InstagramIcon />,
  tiktok: <TiktokIcon />,
  pinterest: <PinterestIcon />,
  whatsapp: <WhatsAppIcon />,
  linkedin: <LinkedInIcon />,
  github: <GitHubIcon />,
};

const InfoRow = ({ icon, label, value }) => (
  <div className="space-y-1">
    <Text is="p" className="text-xs font-bold text-gray-900">
      {label}
    </Text>
    <Text is="p" className="text-sm text-gray-600 leading-relaxed">
      {value}
    </Text>
  </div>
);

export const Contact = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [sendMessage, { isLoading }] = useSendContactMessageMutation();
  const { data: contactPage } = useFetchContactPageQuery();

  const cs = contactPage?.contactSettings;
  const formatSection = (label, sec) => {
    if (!sec) return null;
    const s = sec.start || null;
    const e = sec.end || null;
    if (!s || !e) return `${label}: Closed`;
    return `${label}: ${s} - ${e}`;
  };

  const buildOpening = (opening) => {
    if (!opening) return STORE_INFO.openTime;
    const parts = [];
    const range = opening.weekdays?.range || "";
    const wt = opening.weekdays?.time || {};
    parts.push(range ? `${range} ${wt.start && wt.end ? `${wt.start} - ${wt.end}` : "Closed"}` : (wt.start && wt.end ? `${wt.start} - ${wt.end}` : "Closed"));

    const includesInWeekRange = (range, day) => {
      if (!range) return false;
      const r = range.toLowerCase();
      if (r === "mon-thu") return false;
      if (r === "mon-fri") return day === "friday";
      if (r === "mon-sat") return day === "friday" || day === "saturday";
      if (r === "mon-sun") return day === "friday" || day === "saturday" || day === "sunday";
      return false;
    };

    if (!includesInWeekRange(range, "friday")) {
      const fri = formatSection("Friday", opening.friday);
      if (fri) parts.push(fri);
    }
    if (!includesInWeekRange(range, "saturday")) {
      const sat = formatSection("Saturday", opening.saturday);
      if (sat) parts.push(sat);
    }
    if (!includesInWeekRange(range, "sunday")) {
      const sun = formatSection("Sunday", opening.sunday);
      if (sun) parts.push(sun);
    }

    return parts.join("; ");
  };

  const store = {
    address: cs?.address || STORE_INFO.address,
    phone: cs?.phone || STORE_INFO.phone,
    email: cs?.email || STORE_INFO.email,
    opening_details: buildOpening(cs?.opening),
  };
  const socials = (contactPage?.socialLinks ?? [])
    .filter((s) => SOCIAL_ICONS[s.type])
    .map((s) => ({ icon: SOCIAL_ICONS[s.type], href: s.url || "#", label: s.type }));

  const onSubmit = async (data) => {
    try {
      await sendMessage({
        full_name: data.name,
        phone: data.phone || "",
        email: data.email,
        subject: data.subject,
        message: data.message,
      }).unwrap();
      toast.success("Message sent! We'll get back to you soon.");
      reset();
    } catch {
      toast.error("Failed to send message. Please try again.");
    }
  };

  const formatTime = (t) => {
    if (!t) return null;
    // expect HH:MM or H:MM
    const [hh, mm] = t.split(":");
    if (hh == null) return t;
    let h = parseInt(hh, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 === 0 ? 12 : h % 12;
    const hhStr = String(h).padStart(2, "0");
    return `${hhStr}:${mm} ${ampm}`;
  };

  const OpeningDisplay = ({ opening }) => {
    if (!opening) return <div className="text-sm text-gray-600">{STORE_INFO.openTime}</div>;
    const range = opening.weekdays?.range || "";
    const wt = opening.weekdays?.time || {};
    const buildLine = (label, sec) => (
      <div className="space-y-1">
        <Text is="p" className="text-xs font-semibold text-gray-900">{label}</Text>
        <Text is="p" className="text-sm text-gray-600">{(sec && sec.start && sec.end) ? `${formatTime(sec.start)} To ${formatTime(sec.end)}` : "Closed"}</Text>
      </div>
    );

    const lines = [];
    // Weekdays block heading
    lines.push(
      <div key="weekdays" className="space-y-1">
        <Text is="p" className="text-xs font-semibold text-gray-900">{range || "Weekdays"}</Text>
        <Text is="p" className="text-sm text-gray-600">{(wt && wt.start && wt.end) ? `${formatTime(wt.start)} To ${formatTime(wt.end)}` : "Closed"}</Text>
      </div>
    );

    const includesInWeekRange = (range, day) => {
      if (!range) return false;
      const r = range.toLowerCase();
      if (r === "mon-thu") return false;
      if (r === "mon-fri") return day === "friday";
      if (r === "mon-sat") return day === "friday" || day === "saturday";
      if (r === "mon-sun") return day === "friday" || day === "saturday" || day === "sunday";
      return false;
    };

    if (!includesInWeekRange(range, "friday")) {
      lines.push(<div key="fri">{buildLine("Friday", opening.friday)}</div>);
    }
    if (!includesInWeekRange(range, "saturday")) {
      lines.push(<div key="sat">{buildLine("Saturday", opening.saturday)}</div>);
    }
    if (!includesInWeekRange(range, "sunday")) {
      lines.push(<div key="sun">{buildLine("Sunday", opening.sunday)}</div>);
    }

    return <div className="space-y-1">{lines}</div>;
  };

  return (
    <UserLayout>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />

      <PageHero title="Contact Us" crumbs={[{ label: "Contact Us" }]} />

      {/* Google Map */}
      <div className="w-full h-[480px] relative">
        <iframe
          title="Store location"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3619.725907786927!2d67.05896397537146!3d24.873209277920914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDUyJzIzLjYiTiA2N8KwMDMnNDEuNSJF!5e0!3m2!1sen!2s!4v1779608006262!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <div className="absolute inset-0 bg-black/20 pointer-events-none" />
      </div>

      {/* Content */}
      <div className="max-w-[1440px] mx-auto px-6 lg:px-16 py-16 grid grid-cols-1 lg:grid-cols-2 gap-16">
        {/* Left — Visit Our Store */}
        <div className="space-y-6">
          <Text is="h2" className="text-2xl font-bold text-gray-900">
            Visit Our Store
          </Text>

          <InfoRow label="Address" value={store.address} />
          <InfoRow label="Phone" value={store.phone} />
          <InfoRow label="Email" value={store.email} />
          <div className="space-y-1">
            <Text is="p" className="text-sm font-semibold text-gray-900">Working days and Timings</Text>
            <div className="bg-white dark:bg-slate-800 rounded-md pt-3">
              <OpeningDisplay opening={contactPage?.contactSettings?.opening} />
            </div>
          </div>

          <div className="flex items-center gap-2 pt-2">
            {socials.map(({ icon, href, label }) => (
              <Text
                key={label}
                is="a"
                href={href}
                aria-label={label}
                className="w-8 h-8 border border-gray-300 rounded-sm flex items-center justify-center text-gray-600 hover:border-gray-900 hover:text-gray-900 transition-colors"
              >
                {icon}
              </Text>
            ))}
          </div>
        </div>

        {/* Right — Get in Touch form */}
        <div className="space-y-5">
          <Text is="h2" className="text-2xl font-bold text-gray-900">
            Get in Touch
          </Text>
          <Text is="p" className="text-sm text-gray-500 leading-relaxed">
            If you've got great products you're making or looking to work with
            us then drop us a line.
          </Text>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="space-y-4"
            noValidate
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <input
                  type="text"
                  placeholder="Name *"
                  className={`w-full border px-4 py-3 text-sm outline-none transition-colors placeholder-gray-400 ${errors.name ? "border-blue-400" : "border-gray-200 focus:border-gray-900"}`}
                  {...register("name", { required: "Name is required" })}
                />
                {errors.name && (
                  <Text is="p" className="text-xs text-blue-500 mt-1">
                    {errors.name.message}
                  </Text>
                )}
              </div>
              <div>
                <input
                  type="tel"
                  placeholder="Phone *"
                  className={`w-full border px-4 py-3 text-sm outline-none transition-colors placeholder-gray-400 ${errors.phone ? "border-blue-400" : "border-gray-200 focus:border-gray-900"}`}
                  {...register("phone", { required: "Phone is required" })}
                />
                {errors.phone && (
                  <Text is="p" className="text-xs text-blue-500 mt-1">
                    {errors.phone.message}
                  </Text>
                )}
              </div>
            </div>

            <div>
              <input
                type="email"
                placeholder="Email *"
                className={`w-full border px-4 py-3 text-sm outline-none transition-colors placeholder-gray-400 ${errors.email ? "border-blue-400" : "border-gray-200 focus:border-gray-900"}`}
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid email",
                  },
                })}
              />
              {errors.email && (
                <Text is="p" className="text-xs text-blue-500 mt-1">
                  {errors.email.message}
                </Text>
              )}
            </div>

            <div>
              <input
                type="text"
                placeholder="Subject *"
                className={`w-full border px-4 py-3 text-sm outline-none transition-colors placeholder-gray-400 ${errors.subject ? "border-blue-400" : "border-gray-200 focus:border-gray-900"}`}
                {...register("subject", { required: "Subject is required" })}
              />
              {errors.subject && (
                <Text is="p" className="text-xs text-blue-500 mt-1">
                  {errors.subject.message}
                </Text>
              )}
            </div>

            <div>
              <textarea
                rows={5}
                placeholder="Message"
                className={`w-full border px-4 py-3 text-sm outline-none transition-colors placeholder-gray-400 resize-none ${errors.message ? "border-blue-400" : "border-gray-200 focus:border-gray-900"}`}
                {...register("message")}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gray-900 text-white text-sm font-semibold py-3.5 hover:bg-black transition-colors disabled:opacity-60"
            >
              {isLoading ? "Sending…" : "Send"}
            </button>
          </form>
        </div>
      </div>
    </UserLayout>
  );
};

export default Contact;
